module.exports = __webpack_public_path__ + "img/automotive.36a1cfd6.webp";